import React, { createContext, useContext, useEffect, useState } from "react";

const ThemeContext = createContext(null);

const systemTheme = () =>
  typeof window !== "undefined" && window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";

export function ThemeProvider({ children }) {
  // First visit: follow the phone/OS setting. After the user toggles once, respect their choice.
  const [theme, setTheme] = useState(() => localStorage.getItem("gt_theme") || systemTheme());

  useEffect(() => {
    const root = document.documentElement;
    root.classList.toggle("dark", theme === "dark");
    // Keep the PWA / mobile browser chrome (status bar, address bar) in sync with the theme.
    const meta = document.querySelector('meta[name="theme-color"]');
    if (meta) meta.setAttribute("content", theme === "dark" ? "#0b0b0d" : "#ffffff");
  }, [theme]);

  // Live-follow the system setting until the user makes an explicit choice.
  useEffect(() => {
    const mq = window.matchMedia("(prefers-color-scheme: dark)");
    const onChange = (e) => {
      if (localStorage.getItem("gt_theme_explicit") !== "1") setTheme(e.matches ? "dark" : "light");
    };
    mq.addEventListener("change", onChange);
    return () => mq.removeEventListener("change", onChange);
  }, []);

  const toggle = () =>
    setTheme((t) => {
      const next = t === "dark" ? "light" : "dark";
      localStorage.setItem("gt_theme", next);
      localStorage.setItem("gt_theme_explicit", "1");
      return next;
    });

  return <ThemeContext.Provider value={{ theme, toggle }}>{children}</ThemeContext.Provider>;
}

export const useTheme = () => useContext(ThemeContext);
